import React from 'react'
import PropTypes from 'prop-types'

const Iframe = ({ src, title }) => {
  return (
    <div className="iframe-wrapper">
      <iframe src={src} title={title} scrolling="yes" allowFullScreen frameBorder="0" />
    </div>
  )
}

Iframe.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string
}

export default Iframe